'use client';

import { Suspense } from 'react';
import Downloads from '../components/Downloads';
import DownloadsSkeleton from '../components/DownloadsSkeleton';
import type { DownloadData } from '@/types/download';

interface DownloadsClientProps {
  locale: string;
  data: DownloadData | null;
}

export default function DownloadsClient({ locale, data }: DownloadsClientProps) {
  return (
    <Suspense fallback={<DownloadsSkeleton />}>
      <Downloads locale={locale} data={data} />
    </Suspense>
  );
}
